<template lang="pug">
.v-advantages-block.advantages-block(v-if="block" :class="{'advantages-block--has-arrows': block.items && block.items.length > 5}")
	.advantages-block__container.container
		.advantages-block__wrapper
			.advantages-block__title {{block.title}}
			.advantages-block__advantages-wrapper
				button.advantages-block__arrow.advantages-block__arrow--prev(type="button" ref="adv-prev" aria-label="Предыдущий слайд")
					v-svg-icon.advantages-block__arrow-icon(icon="slide-left")
					v-svg-icon.advantages-block__arrow-bg(icon="slide-left-bg")
				button.advantages-block__arrow.advantages-block__arrow--next(type="button" ref="adv-next" aria-label="Следующий слайд")
					v-svg-icon.advantages-block__arrow-icon(icon="slide-right")
					v-svg-icon.advantages-block__arrow-bg(icon="slide-right-bg")
				v-swiper-slider.advantages-block__slider(:options="options"
						:navigation="navigation"
						@swiper="onSwiper")
					swiper-slide(v-for="(card, cardIndex) in block.items" v-if="block.items && block.items.length" :key="cardIndex")
						.advantages-block__advantage
							img.advantages-block__advantage-img(v-if="card.image" :src="card.image" alt="" loading="lazy")
							.advantages-block__advantage-text
								.advantages-block__advantage-title(v-if="card.title") {{card.title}}
									.advantages-block__advantage-description(v-if="card.description") {{card.description}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from "../scripts/breakpoints.js"
import {SwiperSlide} from "swiper/vue";

export default {
	mixins: [
		sourceMixin
	],

	components: {
		SwiperSlide,
	},

	data() {
		return {
			block: null,
			options: {
				spaceBetween: 6,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: true,
				breakpointsBase: 'container',
				breakpoints: {
					[breakpoints['lg-max']]: {
						spaceBetween: 18,
						slidesPerView: 'auto',
						slidesPerGroup: 5,
					},
					[breakpoints['md-max']]: {
						spaceBetween: 18,
						slidesPerView: 'auto',
						slidesPerGroup: 3,
					},
					[breakpoints['xs-max']]: {
						spaceBetween: 18,
						slidesPerView: 'auto',
						slidesPerGroup: 1,
					},
				},
			},
			allowTouchMove: true,
			pagination: {
				clickable: false,
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs["adv-prev"],
				nextEl: this.$refs["adv-next"],
			};
		},

		dataSet(data) {
			this.block = data;
		}
	}
};
</script>